"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Services() {
  const container = useRef<HTMLDivElement>(null);
  const domains = [{
    label: "Essential Wash",
    caption: "Premium exterior hand wash and tire shine for a pristine finish.",
    alt: "Luxury car exterior being hand washed with premium foam.",
    src: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_4875-1-scaled.jpeg?v=75i5h7t9m8i",
    srcset: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_4227.jpg?v=ynwleu7py4b-wvc-srcset",
    sizes: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_4227.jpg?v=w14sxlq4o9-wvc-sizes",
    link: {
      to: "/ServicesPage"
    }
  }, {
    label: "Interior Deep",
    caption: "Full steam cleaning, leather conditioning, and odor elimination.",
    alt: "Cleaned luxury car interior with leather seats and dashboard.",
    src: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_5244-1.jpeg?v=6e6b2l7vk3i",
    srcset: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_5244-1.jpeg?v=esy5fnpdyja-wvc-srcset",
    sizes: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_5244-1.jpeg?v=bu5vfe7688p-wvc-sizes",
    link: {
      to: "/ServicesPage"
    }
  }];
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".dd-eyebrow", {
        y: 24
      });
      gsap.set(".dd-heading", {
        y: 32
      });
      gsap.set(".dd-lead", {
        y: 24
      });
      gsap.set(".dd-card", {
        y: 40
      });
      gsap.to(".dd-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 78%",
          once: true
        }
      });
      gsap.to(".dd-heading", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        delay: 0.1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 78%",
          once: true
        }
      });
      gsap.to(".dd-lead", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        delay: 0.25,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 78%",
          once: true
        }
      });
      gsap.to(".dd-card", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        stagger: 0.18,
        delay: 0.35,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 78%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".dd-eyebrow", ".dd-heading", ".dd-lead", ".dd-card"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="28773" id="our-signature-services" data-nav="dark" className="relative bg-background text-foreground overflow-hidden" style={{
    paddingTop: "clamp(120px, 18vh, 220px)",
    paddingBottom: "clamp(120px, 18vh, 220px)"
  }}>
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 h-[600px] w-[900px] rounded-lg blur-3xl" style={{
      background: "radial-gradient(closest-side, hsl(41 62% 62% / 0.14), transparent 70%)"
    }} />

      <div ref={container} className="relative mx-auto w-full" style={{
      maxWidth: "1440px",
      paddingLeft: "clamp(24px, 5vw, 88px)",
      paddingRight: "clamp(24px, 5vw, 88px)"
    }}>
        {}
        <div className="mx-auto text-center" style={{
        maxWidth: "760px"
      }}>
          <p className="dd-eyebrow font-sans uppercase text-muted-foreground/80" style={{
          opacity: 0,
          fontSize: "clamp(0.6875rem, 0.8vw, 0.8125rem)",
          fontWeight: 500,
          letterSpacing: "0.22em",
          lineHeight: 1.4
        }}>
            Premium Care &middot; Mobile Detailing
          </p>

          <h2 className="dd-heading font-serif text-foreground" style={{
          opacity: 0,
          marginTop: "24px",
          fontSize: "clamp(2.25rem, 5vw, 4.5rem)",
          fontWeight: 300,
          lineHeight: 1.05,
          letterSpacing: "-0.015em"
        }}>
            Luxury that <em className="italic font-light">arrives</em> to you.
          </h2>

          <p className="dd-lead font-sans mx-auto text-foreground/85" style={{
          opacity: 0,
          marginTop: "20px",
          maxWidth: "520px",
          fontSize: "clamp(1.0625rem, 1.25vw, 1.25rem)",
          fontWeight: 350,
          lineHeight: 1.65
        }}>
            Professional detailing at your home or office in Miami.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2" style={{
        marginTop: "96px",
        columnGap: "32px",
        rowGap: "40px"
      }}>
          {domains.map((item, i) => <div key={item.label} data-index={i} className="dd-card group" style={{
          opacity: 0
        }}>
              <div className="relative overflow-hidden" style={{
            borderRadius: "18px",
            aspectRatio: "3 / 4",
            minHeight: "clamp(300px, 50vh, 600px)"
          }}>
                <Link to="https://inspired-chamois-1.cynergiasites.com/services-servicios/" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03] underline cursor-pointer"><img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" style={{
                transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
              }} /></Link>

                {}
                <div aria-hidden="true" className="absolute inset-0 mix-blend-overlay pointer-events-none" style={{
              opacity: 0.06,
              backgroundImage: "repeating-radial-gradient(ellipse at 50% 60%, hsl(41 62% 62%) 0px, hsl(41 62% 62%) 1px, transparent 1px, transparent 22px)"
            }} />

                {}
                <div aria-hidden="true" className="absolute inset-0 pointer-events-none transition-opacity duration-500 group-hover:opacity-100" style={{
              background: "linear-gradient(to top, hsl(258 18% 6%) 0%, hsl(258 18% 6% / 0.6) 30%, transparent 70%)"
            }} />

                {}
                <div className="absolute left-0 bottom-0" style={{
              padding: "clamp(24px, 3vw, 36px)"
            }}>
                  <h3 className="font-serif text-foreground" style={{
                fontSize: "clamp(1.5rem, 2.4vw, 2.25rem)",
                fontWeight: 400,
                lineHeight: 1.15,
                letterSpacing: "-0.01em"
              }}>
                    {item.label}
                  </h3>
                </div>

                {}
                <div className="absolute top-0 right-0" style={{
              padding: "clamp(20px, 2.4vw, 28px)"
            }}>
                  <Link to="https://inspired-chamois-1.cynergiasites.com/services-servicios/" className="flex items-center justify-center rounded-lg border transition-colors duration-[400ms] group-hover:border-[hsl(41_62%_62%)] underline cursor-pointer size-12">
                    <ArrowUpRight className="size-5 text-foreground" />
                  </Link>
                </div>
              </div>

              {}
              <p className="font-sans text-muted-foreground" style={{
            marginTop: "24px",
            fontSize: "clamp(0.8125rem, 0.9vw, 0.875rem)",
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: "0.02em"
          }}>
                {item.caption}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}